import {
  FETCH_PAYMENTISSUE_REQUEST,
  FETCH_PAYMENTISSUE_SUCCESS,
  FETCH_PAYMENTISSUE_FAILURE,
  SEARCH_PAYMENTISSUE_REQUEST,
  SEARCH_PAYMENTISSUE_SUCCESS,
  SEARCH_PAYMENTISSUE_FAILURE
} from "./paymentIssuesAction";

const initialState = {
  loading: false,
  paymentIssuesData: [],
  searchResults: [],
  error: "",
};

const getPaymentIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTISSUE_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case FETCH_PAYMENTISSUE_SUCCESS:
      return {
        loading: false,
        paymentIssuesData: [...state.paymentIssuesData, ...action.payload],
        error: "",
      };
    case FETCH_PAYMENTISSUE_FAILURE:
      return {
        loading: false,
        paymentIssuesData: [],
        error: action.payload,
      };
    case SEARCH_PAYMENTISSUE_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_PAYMENTISSUE_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        error: '',
      };
    case SEARCH_PAYMENTISSUE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default getPaymentIssueReducer;
